import Fuse from "fuse.js";
import { User } from "../types/access";

export const searchArrayOfUsers = (searchValue: string, users: User[]) => {
    const fuse = new Fuse(users, {
        threshold: 0.2,
        keys: ["email", "role", "displayName"],
    });
    const results = fuse.search(searchValue).map((result) => result.item);
    return results as User[];
};

export const getFormFieldsFromUser = (user: User): User => {
    return {
        email: user.email,
        displayName: user.displayName,
        role: user.role,
        password: "",
    };
};

export const verifyForm = ({
    fields,
    isUpdating,
}: {
    fields: User;
    isUpdating?: boolean;
}) =>
    new Promise(
        (resolve: (res: string) => void, reject: (err: string) => void) => {
            if (!fields.email) reject("Email is empty");
            if (!fields.displayName) reject("Display name is empty");
            if (!fields.role) reject("Role is empty");
            if (!isUpdating && !fields.password) reject("Password is empty");
            if (!isUpdating && fields.password && fields.password.length < 6)
                reject("Password must be at least 6 characters");

            resolve("Success");
        }
    );
